/* Pop-up: join MESMO Circle.
   Opens once after a few seconds or after some scrolling. Closing it keeps it away for a number of
   days; joining (here or anywhere else on the site) keeps it away for good on this device.
   The sign-up goes through Shopify's own customer form and is sent in the background, so the
   visitor stays on the page. */
(function () {
  'use strict';

  var popup = document.querySelector('[data-circle-popup]');
  if (!popup) return;

  var KEY = 'mesmo:circle-popup';
  var PENDING = 'mesmo:circle-popup-pending';
  var DAY = 24 * 60 * 60 * 1000;

  var form = popup.querySelector('[data-cpop-form]');
  var input = popup.querySelector('[data-cpop-email]');
  var submit = popup.querySelector('[data-cpop-submit]');
  var errorBox = popup.querySelector('[data-cpop-error]');
  var preview = popup.getAttribute('data-preview') === 'true';
  var delay = (Number(popup.getAttribute('data-delay')) || 8) * 1000;
  var scrollShare = (Number(popup.getAttribute('data-scroll')) || 40) / 100;
  var snooze = (Number(popup.getAttribute('data-snooze')) || 14) * DAY;
  var opened = false;
  var busy = false;
  var lastFocus = null;
  var failTimer = null;

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || 'null');
    } catch (error) {
      return null;
    }
  }

  function write(value) {
    try {
      localStorage.setItem(KEY, JSON.stringify(value));
    } catch (error) {
      /* private window: the pop-up may show again next time */
    }
  }

  function markJoined() {
    write({ joined: true });
  }

  function pending(value) {
    try {
      if (value === undefined) return sessionStorage.getItem(PENDING);
      if (value === null) sessionStorage.removeItem(PENDING);
      else sessionStorage.setItem(PENDING, value);
    } catch (error) {
      return null;
    }
    return null;
  }

  function step(name) {
    Array.prototype.forEach.call(popup.querySelectorAll('[data-cpop-step]'), function (part) {
      part.hidden = part.getAttribute('data-cpop-step') !== name;
    });
  }

  function open(which) {
    if (opened) return;
    opened = true;
    step(which || 'join');
    lastFocus = document.activeElement;
    popup.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    window.requestAnimationFrame(function () {
      popup.classList.add('is-open');
    });
    var panel = popup.querySelector('.cpop__panel');
    if (panel) panel.focus({ preventScroll: true });
  }

  function close() {
    if (popup.hidden) return;
    popup.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    window.setTimeout(function () {
      popup.hidden = true;
    }, 300);
    var state = read();
    if (!state || !state.joined) write({ until: Date.now() + snooze });
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function showError(message) {
    errorBox.textContent = message || '';
    errorBox.hidden = !message;
  }

  function release() {
    busy = false;
    window.clearTimeout(failTimer);
    submit.removeAttribute('aria-busy');
  }

  function done() {
    release();
    pending(null);
    markJoined();
    input.value = '';
    step('done');
    var button = popup.querySelector('[data-cpop-step="done"] .button');
    if (button) button.focus({ preventScroll: true });
  }

  function failed(response) {
    if (response && response.url && response.url.indexOf('/challenge') !== -1) {
      /* Shopify wants to ask "are you a robot?" on a page of its own first */
      window.location.href = response.url;
      return;
    }
    pending(null);
    release();
    showError(popup.getAttribute('data-failed'));
  }

  /* Shopify's spam check calls form.submit() once it has added its answer. That moment is
     taken over here, so the form is sent in the background. */
  if (window.fetch && window.FormData) {
    form.submit = function () {
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .then(function (response) {
          if (response.ok && response.url.indexOf('customer_posted=true') !== -1) done();
          else failed(response);
        })
        .catch(function () {
          failed(null);
        });
    };
  }

  function bound() {
    return !!(form.dataset.hcaptchaBound || form.dataset.recaptchaBound);
  }

  function valid(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  form.addEventListener('submit', function (event) {
    if (form.dataset.cpopGo === 'true') {
      form.dataset.cpopGo = '';
      return;
    }
    var email = input.value.trim();
    if (!valid(email)) {
      event.preventDefault();
      showError(popup.getAttribute('data-invalid'));
      input.focus();
      return;
    }
    if (busy) {
      event.preventDefault();
      return;
    }
    busy = true;
    showError('');
    submit.setAttribute('aria-busy', 'true');
    pending('1');
    failTimer = window.setTimeout(function () {
      failed(null);
    }, 15000);
    if (bound()) return;
    /* The spam check is not attached yet: wake it and send again once it is */
    event.preventDefault();
    input.dispatchEvent(new Event('focusin', { bubbles: true }));
    var tries = 0;
    (function again() {
      if (!bound() && tries < 30) {
        tries += 1;
        window.setTimeout(again, 200);
        return;
      }
      form.dataset.cpopGo = bound() ? '' : 'true';
      if (form.requestSubmit) form.requestSubmit(submit);
      else submit.click();
    })();
  });

  popup.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('[data-cpop-close]')) close();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !popup.hidden) close();
  });

  /* Keep keyboard focus inside the pop-up while it is open */
  popup.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var items = Array.prototype.filter.call(
      popup.querySelectorAll('button, a[href], input:not([type="hidden"])'),
      function (item) {
        return item.offsetParent !== null;
      }
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* ---- When to show ---- */

  var posted = window.location.search.indexOf('customer_posted=true') !== -1;

  /* Back from Shopify's robot check (or a normal page post) after joining here */
  if (pending() && posted) {
    pending(null);
    markJoined();
    open('done');
    return;
  }
  if (pending() && window.location.pathname.indexOf('/challenge') === -1) pending(null);

  /* Joined somewhere else on the site (footer, MESMO Circle page): the page reloads with this mark */
  if (posted) markJoined();

  if (preview) {
    open('join');
    return;
  }

  var state = read();
  if (state && (state.joined || (state.until && state.until > Date.now()))) return;

  function busyElsewhere() {
    var cart = document.querySelector('[data-cart-drawer]');
    if (cart && !cart.hidden) return true;
    var active = document.activeElement;
    if (active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName) && !popup.contains(active)) return true;
    /* Joined in the cart without a reload */
    var joined = document.querySelector('[data-join-done]:not([hidden])');
    if (joined) {
      markJoined();
      return true;
    }
    return false;
  }

  var timer = null;

  function tryOpen() {
    var latest = read();
    if (opened || (latest && latest.joined)) return stop();
    if (busyElsewhere()) {
      window.clearTimeout(timer);
      timer = window.setTimeout(tryOpen, 4000);
      return;
    }
    stop();
    open('join');
  }

  function onScroll() {
    var room = document.documentElement.scrollHeight - window.innerHeight;
    if (room > 0 && window.scrollY / room >= scrollShare) tryOpen();
  }

  function stop() {
    window.clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
  }

  timer = window.setTimeout(tryOpen, delay);
  window.addEventListener('scroll', onScroll, { passive: true });
})();
